module.exports = __webpack_public_path__ + "img/RTE-Logo.e589d599.svg";